import classnames from 'classnames';
import React from 'react';

export const StickyHeader = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <h3
    className={classnames(
      'sticky top-0 z-10 border-b border-primary bg-secondary-inverted pb-2 pt-4 text-lg font-semibold',
      className,
    )}
  >
    {children}
  </h3>
);
